import { Injectable, OnDestroy } from "@angular/core";
import { EventType, NavigationEnd, Router } from "@angular/router";
import { BehaviorSubject, Subscription } from "rxjs";
import { filter, map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class TargetIdService implements OnDestroy {
  public readonly targetId: BehaviorSubject<string | null>;

  private subscription: Subscription;

  constructor(router: Router) {
    this.targetId = new BehaviorSubject<string | null>(
      this.getHash(router.url),
    );
    this.subscription = router.events
      .pipe(
        filter(
          (ev): ev is NavigationEnd => ev.type === EventType.NavigationEnd,
        ),
        map(({ urlAfterRedirects }) => this.getHash(urlAfterRedirects)),
      )
      .subscribe(this.targetId);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private getHash(url: string) {
    const hashIndex = url.indexOf("#");
    if (hashIndex <= 0) {
      return null;
    } else {
      const hashVal = decodeURIComponent(url.slice(hashIndex + 1));
      return hashVal;
    }
  }
}
